export default __webpack_public_path__ + "static/media/copy-icon.a2a3268c.svg";